module.exports = __webpack_public_path__ + "assets/fonts/opensans-regular_eb3f297.woff";